import Modal from "react-bootstrap/Modal";
import { useCallback, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { buildPublicEventShareUrl } from "../../utils/eventShareUrl";

export const SocialLinkModal = (props) => {
  const { eventId, show, onHide, isHideEmbeded } = props;
  const [sharedlinkCopied, setSharedLinkCopied] = useState(false);
  const [embedlinkCopied, setEmbedLinkCopied] = useState(false);
  const sharedInputRef = useRef(null);
  const embedInputRef = useRef(null);
  const location = useLocation();
  const referralId = useMemo(
    () => new URLSearchParams(location.search).get("referralId"),
    [location.search]
  );

  const sharedUrl = useMemo(
    () => buildPublicEventShareUrl(eventId, { referralId }),
    [eventId, referralId]
  );

  const embedUrl = useMemo(() => {
    if (!sharedUrl) {
      return "";
    }
    return `<iframe src="${sharedUrl}" frameborder="0" width="700" height="400"></iframe>`;
  }, [sharedUrl]);

  const shareOnFacebook = useCallback(() => {
    const navUrl =
      "https://www.facebook.com/sharer/sharer.php?u=" +
      encodeURIComponent(sharedUrl);
    window.open(navUrl, "_blank");
  }, [sharedUrl]);

  const shareOnTwitter = useCallback(() => {
    const navUrl =
      "https://twitter.com/intent/tweet?text=" +
      encodeURIComponent(sharedUrl);
    window.open(navUrl, "_blank");
  }, [sharedUrl]);

  const handleCopySharedTextFromArea = () => {
    sharedInputRef.current?.select();
    document.execCommand("copy");
    setEmbedLinkCopied(false);
    setSharedLinkCopied(true);
  };

  const handleCopyEmbedTextFromArea = () => {
    embedInputRef.current?.select();
    document.execCommand("copy");
    setSharedLinkCopied(false);
    setEmbedLinkCopied(true);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      centered
      animation={false}
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="event-share-modal-dialog"
      contentClassName="event-share-modal"
    >
      <Modal.Header className="event-share-modal-header" closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Share Event
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="event-share-modal-body">
        <div className="event-share-social">
          <button
            type="button"
            className="event-share-social-link is-facebook"
            onClick={shareOnFacebook}
            aria-label="Share on Facebook"
          >
            <i className="lab la-facebook-f" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            className="event-share-social-link is-twitter"
            onClick={shareOnTwitter}
            aria-label="Share on Twitter"
          >
            <i className="lab la-twitter" aria-hidden="true"></i>
          </button>
        </div>

        <div className="event-share-field">
          <label htmlFor="clipboard-area-shared">Shared Link</label>
          <div className="event-share-input-row">
            <input
              ref={sharedInputRef}
              className="event-share-input"
              id="clipboard-area-shared"
              value={sharedUrl}
              readOnly
            />
            <button
              type="button"
              className={`event-share-copy-btn${
                sharedlinkCopied ? " is-copied" : ""
              }`}
              onClick={handleCopySharedTextFromArea}
              aria-label="Copy shared link"
            >
              <i
                className={`fa fa-light ${
                  sharedlinkCopied ? "fa-check" : "fa-paste"
                }`}
                aria-hidden="true"
              ></i>
            </button>
          </div>
        </div>

        {!isHideEmbeded && (
          <div className="event-share-field">
            <label htmlFor="clipboard-area-embed">Embed Link</label>
            <div className="event-share-input-row">
              <input
                ref={embedInputRef}
                className="event-share-input"
                id="clipboard-area-embed"
                value={embedUrl}
                readOnly
              />
              <button
                type="button"
                className={`event-share-copy-btn${
                  embedlinkCopied ? " is-copied" : ""
                }`}
                onClick={handleCopyEmbedTextFromArea}
                aria-label="Copy embed link"
              >
                <i
                  className={`fa fa-light ${
                    embedlinkCopied ? "fa-check" : "fa-paste"
                  }`}
                  aria-hidden="true"
                ></i>
              </button>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="event-share-modal-footer">
        <button
          type="button"
          className="event-share-modal-btn-close"
          onClick={onHide}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};
